import styled, { css } from 'styled-components';

export const PanelMobile = styled.article`
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 25px;
  
  background: ${({ theme }) => theme.white};
  border-radius: 6px 6px 0 0;
  box-shadow: 0px -8px 24px rgba(0, 0, 0, 0.08);
  
  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileButton = styled.div`
  button {
    padding: 10px 20px;
    
    line-height: 1;
  }
`;

export const MobileTotal = styled.div`
  h3 {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    
    font-size: 16px;
    line-height: 1;
  }
  
  p {
    margin: 0;
    padding: 0;
    
    font-weight: 700;
    font-size: 24px;
    line-height: 1;
  }
`;

export const PanelContainer = styled.article`
  @media (min-width: 768px) {
    padding: 0 25px;
    padding-top: 15px;
    padding-bottom: 35px;
    
    border-radius: 6px;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
`;

export const PanelImageContainer = styled.div`
  height: 185px;
  margin-bottom: 20px;

  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
  
  @media (min-width: 768px) {
    height: 220px;
  }
`;

export const PanelPaymentInfo = styled.div``;

export const PanelPaymentDelimiter = styled.hr`
  margin: 10px 0;
  padding: 0;

  border: none;
  border-bottom: 1px solid #ececec;
`;

export const PanelAccordion = styled.div`
  margin: -5px 0;
`;

export const PanelButton = styled.button`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 15px 0;

  font-weight: 600;
  font-size: 16px;
  line-height: 1;

  transition: color 0.3s;

  &::after {
    content: '';

    transform: rotate(90deg);

    display: inline-block;
    width: 6px;
    height: 9px;
    margin-left: 20px;

    background: transparent no-repeat center / contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

    transition: background-image 0.3s, margin-left 0.3s;

    pointer-events: none;
  }

  &:hover {
    color: ${({theme}) => theme.black};

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%23505050' fill-rule='evenodd' stroke='%23505050' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");
    }
  }

  ${({isOpen}) => isOpen && css`
    &::after {
      transform: rotate(270deg);
    }
  `}
`;

export const PanelMessage = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 5px;
  padding-bottom: 15px;
  
  font-size: 16px;
  line-height: 18px;
  
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
  
  li {
    font-size: 14px;
    line-height: 20px;
    
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    
    &::before {
      content: "";
      
      display: inline-block;
      vertical-align: middle;
      width: 4px;
      height: 4px;
      margin-right: 5px;
      
      background-color: #9a9a9a;
      border-radius: 50%;
    }
  }
`;

export const PanelPaymentItem = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 10px 0;
  
  font-size: 16px;
  line-height: 1;
  text-align: left;

  span {
    & > span {
      display: block;
    }
    
    &.row {
      display: flex;
      align-items: center;
    }
  
    &.subtitle {
      display: block;
      margin-top: 10px;
    }
  
    &.normal {
      font-weight: 400;
    }
    
    &.semibold {
      font-weight: 600;
    }
    
    &.bold {
      font-weight: 700;
    }
    
    &.blue {
      color: ${({ theme }) => theme.blue};
    }
    
    &.small {
      font-size: 14px;
    }
    
    &.medium {
      font-size: 20px;
    }
    
    &.large {
      font-size: 24px;
    }
  }
`;

export const PerkBadge = styled.span`
  display: inline-block;
  margin: 0;
  margin-right: 30px;
  padding: 10px;
  flex-shrink: 0;
  
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  color: #783004;
  
  background-color: #fbd304;
  border-radius: 20px 0 20px 0;
`;

export const PanelPaymentHeading = styled.h3`
  margin: 0;
  margin-top: 40px;
  margin-bottom: 10px;
  padding: 0;
  
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

export const PanelPaymentButtonContainer = styled.div`
  margin-top: 30px;
  
  button {
    padding-left: 40px;
    padding-right: 40px;
  }
  
  @media (min-width: 768px) {
    padding: 0 5px;
    
    button {
      width: 100%;
    }
  }
`;

export const CheckboxDescription = styled.p`
  margin-top: 0;
  color: ${({ theme, hasError }) => hasError ? theme.red : theme.black};
`;

export const PanelPaymentCheckboxContainer = styled.div`
  margin-top: 25px;
  
  ${CheckboxDescription} {
    margin-top: 0;
  
    font-size: 14px;
    line-height: 16px;
    
    a {
      font-weight: 700;
      color: ${({ theme }) => theme.blue};
      
      transition: color 0.3s;
      
      &:hover {
        font-weight: 700;
        color: ${({ theme }) => theme.black};
      }
    }
  }
`;
